/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

export default {
    baseStyle: () => ({
        countdowntimerBlock: {
            clear: 'both',
            padding: '0 16px 0 0',
            borderTop: '6px solid #141519',
            boxShadow: '0 2px 4px 0 rgba(0,0,0,.2)',
            position: 'relative',
            zIndex: 1
        },
        mobileCountdownLink: {
            display: ['block', 'none'],
            position: 'absolute',
            width: '100%',
            height: '100%',
            zIndex: 1
        },
        countdowntimerInnerBlock: {
            justifyContent: 'flex-end',
            maxWidth: ['100%', '100%', '100%', '100%', '100%', '1920px'],
            margin: '0 auto',
            display: 'flex',
            position: 'relative'
        },
        imageBlock: {
            width: ['65px', '104px', '144px'],
            backgroundRepeat: 'no-repeat',
            position: 'absolute',
            left: ['6px', '0'],
            height: ['50px', '84px', '92px'],
            backgroundPosition: ['1px 0px', '0px 2px'],
            bottom: '0',
            backgroundSize: ['100%', 'contain', 'contain', '']
        },
        countdowntimerTextTimerBlock: {
            width: '100%',
            padding: ['0 0', '11px 0', '11px 0', '12px 0'],
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginLeft: '4',
            minHeight: ['45px', 'unset']
        },
        countdowntimerTextTimerLeftBlock: {
            paddingRight: '15px'
        },
        mainHeading: {
            color: 'headerBgColor',
            fontSize: {base: 'md', xl: 'xl'},
            fontWeight: 'extrabold',
            lineHeight: {base: '5', xl: '8'},
            margin: 0
        },
        subHeading: {
            color: 'headerBgColor',
            fontSize: {base: 'xs', xl: 'md'},
            fontWeight: 'extrabold',
            lineHeight: {base: '4', xl: '8'},
            margin: 0,
            display: ['none', 'block']
        },
        countdowntimerTextTimerRightBlock: {
            display: 'flex',
            alignItems: 'center'
        },
        clockBlock: {
            display: 'flex',
            alignItems: 'center'
        },
        digitsBg: {
            background: 'textColorInvert',
            padding: ['5px 0', '12px 15px'],
            width: ['35px', '64px'],
            height: ['38px', '56px'],
            borderRadius: 'lg',
            textAlign: 'center',
            color: '#141519',
            fontSize: ['20px', '25px'],
            fontWeight: 'extrabold',
            lineHeight: ['7', '8']
        },
        colon: {
            padding: ['0 2px', '0 2px', '0 15px'],
            fontWeight: 'extrabold',
            color: 'black',
            fontSize: ['2xl', '3xl']
        },
        buttonBlock: {
            marginLeft: '3'
        },
        countdownLink: {
            borderRadius: 'lg',
            padding: '14px 36px',
            lineHeight: '5',
            fontSize: 'md',
            fontWeight: 'extrabold',
            whiteSpace: 'nowrap',
            textTransform: 'capitalize'
        },
        shopNowLink: {
            color: 'white',
            backgroundColor: 'black'
        }
    })
}
